import { hydrate } from "@propublica/pp-svelte/util/hydrate-baker.mjs";
import enhanceShortenedTables from "@propublica/pp-v5-shared/src/js/table.shortened.js";

import * as componentClasses from "./svelte-components.js";
import "./scrollies.js";

// @ts-ignore (TODO(@alecglassford): Fix type problems with componentClasses)
hydrate(componentClasses);
enhanceShortenedTables();
